
{
  "familyId": "TAA-SIGNAALWOORD",
  "questions": [
    {
      "id": "TAA-SIGNAALWOORD-001",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord geeft een tegenstelling aan?",
      "context": "Het regende hard. Toch gingen we naar buiten.",
      "options": ["Toch", "Hard", "Naar", "We"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoorden: tegenstelling",
            "content": "Tegenstellingswoorden geven aan dat iets anders is dan verwacht. Voorbeelden: toch, maar, echter, hoewel, ondanks, daarentegen. 'Toch' geeft aan: ondanks de regen gingen ze naar buiten.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_contrast",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: signaalwoorden geven de relatie tussen zinnen aan. Stap 1: De eerste zin beschrijft regen (oorzaak om binnen te blijven). Stap 2: De tweede zin beschrijft het tegenovergestelde (naar buiten gaan). Stap 3: 'Toch' is het signaalwoord dat deze tegenstelling aangeeft.",
        "distractorExplanations": {
          "0": "Correct! 'Toch' is een signaalwoord voor tegenstelling — het geeft aan dat iets anders gaat dan verwacht.",
          "1": "'Hard' is een bijwoord dat beschrijft hoe het regende, geen signaalwoord.",
          "2": "'Naar' is een voorzetsel (richting), geen signaalwoord.",
          "3": "'We' is een voornaamwoord (persoon), geen signaalwoord."
        }
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-002",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord geeft een oorzaak-gevolg aan?",
      "context": "De weg was glad. Daardoor slipte de auto.",
      "options": ["Daardoor", "Was", "Glad", "De"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoorden: oorzaak-gevolg",
            "content": "Oorzaak-gevolgwoorden verbinden een reden met een resultaat. Voorbeelden: daardoor, daarom, want, omdat, hierdoor, dus. 'Daardoor' geeft aan: de gladde weg (oorzaak) → de auto slipte (gevolg).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_cause_effect",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: zoek het woord dat oorzaak en gevolg verbindt. Stap 1: Oorzaak = de weg was glad. Stap 2: Gevolg = de auto slipte. Stap 3: 'Daardoor' verbindt deze twee: de gladde weg veroorzaakte het slippen.",
        "distractorExplanations": {
          "0": "Correct! 'Daardoor' is een signaalwoord voor oorzaak-gevolg.",
          "1": "'Was' is een werkwoord (koppelwerkwoord), geen signaalwoord.",
          "2": "'Glad' is een bijvoeglijk naamwoord, geen signaalwoord.",
          "3": "'De' is een lidwoord, geen signaalwoord."
        }
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-003",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "text_highlight",
      "question": "Klik op het signaalwoord in deze zin:",
      "context": "We wilden gaan zwemmen, maar het zwembad was gesloten.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "We wilden gaan zwemmen, maar het zwembad was gesloten.",
        "correctHighlights": [{"start": 26, "end": 30}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoord herkennen",
            "content": "'Maar' is een signaalwoord voor tegenstelling. Het verbindt twee tegengestelde ideeën: willen zwemmen ↔ zwembad gesloten.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_highlight",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "'Maar' is het signaalwoord. Het geeft een tegenstelling aan: ze wilden zwemmen (verwachting) ↔ het zwembad was gesloten (werkelijkheid).",
        "distractorExplanations": {
          "0": "Correct! 'Maar' is het signaalwoord (tegenstelling)."
        }
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-004",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "matching",
      "question": "Koppel elk signaalwoord aan het juiste type verband.",
      "context": null,
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Omdat", "Maar", "Bovendien", "Daarna"],
        "rightItems": ["Oorzaak-gevolg", "Tegenstelling", "Opsomming", "Tijd"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Soorten signaalwoorden",
            "content": "Oorzaak-gevolg: omdat, want, daardoor. Tegenstelling: maar, toch, echter. Opsomming: bovendien, ook, daarnaast. Tijd: daarna, vervolgens, ten slotte.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_matching",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Omdat = oorzaak-gevolg (geeft een reden). Maar = tegenstelling (geeft een contrast). Bovendien = opsomming (voegt iets toe). Daarna = tijd (geeft volgorde aan)."
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-005",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord past het best? 'Eerst maakten we huiswerk. ___ gingen we buiten spelen.'",
      "context": null,
      "options": ["Daarna", "Omdat", "Maar", "Want"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoord kiezen",
            "content": "De zinnen beschrijven een volgorde in tijd: eerst huiswerk, dan buiten spelen. 'Daarna' is het juiste tijdssignaalwoord.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_choose",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: bepaal het verband tussen de zinnen. Stap 1: 'Eerst' geeft aan dat er een volgorde is. Stap 2: Na het huiswerk volgt buiten spelen. Stap 3: 'Daarna' is het tijdssignaalwoord dat deze volgorde aangeeft.",
        "distractorExplanations": {
          "0": "Correct! 'Daarna' geeft de tijdsvolgorde aan: eerst huiswerk, daarna buiten spelen.",
          "1": "'Omdat' geeft een reden aan. De zinnen beschrijven geen oorzaak-gevolg, maar een volgorde.",
          "2": "'Maar' geeft een tegenstelling aan. Er is hier geen tegenstelling — beide activiteiten gebeuren.",
          "3": "'Want' geeft een reden aan. De zinnen beschrijven een volgorde, geen reden."
        }
      }
    }
  ]
}
